<template>
  <div>
    <MetricFilters
      class="tw-mb-3"
      filters-state-relative-path="permitStatusMetricsFilters"
    />
    <div class="tw-w-full tw-h-32 tw-mb-2">
      <canvas
        ref="PermitStatusesBarChart"
      />
    </div>
    <AdministrationTableHeader
      store-path="v2/admin/dashboard"
      filters-state-relative-path="permitStatusMetricsFilters"
      filters-mutation-relative-path="sortPermitStatusMetricsByUser"
      :columns="columns"
      :need-to-translate-column-title="false"
    />
    <div class="tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl">
      <template
        v-for="(userMetric, index) in permitStatusMetricsByUser"
        :key="userMetric.actor_id"
      >
        <div
          v-if="index > 0"
          class="tw-w-full tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
        />
        <div
          class="tw-flex tw-items-center tw-py-1.5 tw-px-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light"
        >
          <div
            class="tw-flex tw-items-center tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[0].width}`"
          >
            {{ userMetric.fullname }}
          </div>

          <div :style="`width: ${columns[1].width}`">
            {{ userMetric.filled ?? '-' }}
          </div>

          <div
            class="tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[2].width}`"
          >
            {{ userMetric.skipped ?? '-' }}
          </div>

          <div
            class="tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[3].width}`"
          >
            {{ userMetric.completion_rate ? userMetric.completion_rate + ' %' : '-' }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { permitStatusMetricsTableColumns } from '@/views/admin/dashboard/constants';
import MetricFilters from '@/views/admin/dashboard/components/MetricFilters.vue';
import { Chart } from 'chart.js';
import { shallowRef } from 'vue';
import AdministrationTableHeader from '@/components/Administration/components/AdministrationTableHeader.vue';


export default {
  name: 'PermitStatusesMetricsTable',
  components: { AdministrationTableHeader, MetricFilters },
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    ...mapState({
      permitStatusMetricsByUser: (state) => state.v2.admin.dashboard.permitStatusMetricsByUser,
      permitStatusTotalMetrics: (state) => state.v2.admin.dashboard.permitStatusTotalMetrics,
    }),
    columns() {
      return permitStatusMetricsTableColumns(this.$t);
    },
    chartData() {
      const metrics = this.permitStatusTotalMetrics;
      return {
        skipped: Number(metrics.skipped ?? 0),
        filled: Number(metrics.filled ?? 0),
      };
    },
  },
  watch: {
    chartData: {
      handler(newValue) {
        this.updateChart(newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initChart();
    if (this.chartData.skipped && this.chartData.filled) {
      this.updateChart(this.chartData);
    }
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  methods: {
    updateChart(data) {
      if (!this.chart) return;
      const chartInstance = this.chart;
      chartInstance.data.datasets[0].data = [data.skipped];
      chartInstance.data.datasets[1].data = [data.filled];
      chartInstance.update();
    },
    initChart() {
      const ctx = this.$refs.PermitStatusesBarChart;
      if (!ctx) return;

      const data = this.chartData;

      this.chart = shallowRef(new Chart(ctx, {
        type: 'bar',
        data: {
          labels: [''],
          datasets: [
            {
              label: this.$t('dashboard.permit_metrics.skipped'),
              data: [data.skipped],
              backgroundColor: '#E99C60',
              barThickness: 30,
            },
            {
              label: this.$t('dashboard.permit_metrics.filled'),
              data: [data.filled],
              backgroundColor: '#74BD3A',
              barThickness: 30,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            },
          },
          scales: {
            x: {
              stacked: true,
              beginAtZero: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      }));
    },
  },
};
</script>
